// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_b5-b";
export var colorBlue = "_b5-8";
export var colorDot = "_b5-0";
export var colorDotLarge = "_b5-2";
export var colorDotSmall = "_b5-1";
export var colorGreen = "_b5-7";
export var colorGrey = "_b5-3";
export var colorOrange = "_b5-5";
export var colorPink = "_b5-a";
export var colorPurple = "_b5-9";
export var colorRed = "_b5-4";
export var colorYellow = "_b5-6";